(() => {
  const ready = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  const initializeRotators = (scope = document) => {
    scope.querySelectorAll('[data-bazzai-rotator]').forEach((rotator) => {
      if (rotator.dataset.initialized === 'true') return;

      const words = (rotator.dataset.words || '')
        .split('|')
        .map((word) => word.trim())
        .filter(Boolean);

      if (words.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      rotator.dataset.initialized = 'true';
      let index = 0;
      let lastTick = 0;
      window.setInterval(() => {
        // Background tabs throttle intervals and replay queued ticks in a
        // burst on refocus, which strobes the word at opacity 0. Gate on
        // wall-clock spacing so catch-up ticks are no-ops.
        const now = Date.now();
        if (document.hidden || now - lastTick < 1500) return;
        lastTick = now;
        index = (index + 1) % words.length;
        rotator.classList.remove('is-changing');
        void rotator.offsetWidth;
        rotator.textContent = words[index];
        rotator.classList.add('is-changing');
      }, 2200);
    });
  };

  const initializeTabs = (scope = document) => {
    scope.querySelectorAll('[data-bazzai-filter]').forEach((filter) => {
      if (filter.dataset.initialized === 'true') return;
      filter.dataset.initialized = 'true';

      const buttons = filter.querySelectorAll('[data-bazzai-filter-button]');
      const targetSelector = filter.dataset.target;
      const target = targetSelector ? document.querySelector(targetSelector) : filter;
      if (!target) return;

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          const value = button.dataset.bazzaiFilterButton || 'all';
          buttons.forEach((candidate) => {
            const active = candidate === button;
            candidate.classList.toggle('is-active', active);
            candidate.setAttribute('aria-selected', String(active));
          });

          target.querySelectorAll('[data-bazzai-filter-item]').forEach((item) => {
            const groups = (item.dataset.bazzaiFilterItem || '').split('|');
            item.hidden = value !== 'all' && !groups.includes(value);
          });
        });
      });
    });
  };

  const initializeVotes = (scope = document) => {
    scope.querySelectorAll('[data-bazzai-vote]').forEach((button) => {
      if (button.dataset.initialized === 'true') return;
      button.dataset.initialized = 'true';

      const productId = button.dataset.productId;
      if (!productId) return;
      const storageKey = `bazzai:voted:${productId}`;
      const countNode = button.querySelector('[data-bazzai-vote-count]');
      const iconNode = button.querySelector('[data-bazzai-vote-icon]');
      const saved = window.localStorage.getItem(storageKey) === 'true';

      const render = (active) => {
        button.setAttribute('aria-pressed', String(active));
        if (iconNode) iconNode.textContent = active ? '♥' : '♡';
      };

      render(saved);
      button.addEventListener('click', async () => {
        const active = button.getAttribute('aria-pressed') === 'true';
        if (active) return;

        const current = Number.parseInt(countNode?.textContent || '0', 10) || 0;
        render(true);
        if (countNode) countNode.textContent = String(current + 1);
        window.localStorage.setItem(storageKey, 'true');

        const endpoint = button.dataset.endpoint;
        if (!endpoint) return;
        try {
          await window.fetch(endpoint, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ product_id: productId }),
          });
        } catch (_error) {
          // Keep the optimistic visitor state. The storefront remains responsive
          // when the optional vote proxy is unavailable.
        }
      });
    });
  };

  const initializeCountdowns = (scope = document) => {
    scope.querySelectorAll('[data-bazzai-countdown]').forEach((countdown) => {
      const target = countdown.dataset.eventDate;
      if (!target) return;

      const eventDate = new Date(`${target}T00:00:00`);
      if (Number.isNaN(eventDate.getTime())) return;
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const days = Math.max(0, Math.ceil((eventDate - today) / 86400000));
      const value = countdown.querySelector('[data-bazzai-countdown-value]');
      if (value) value.textContent = `${days} ${days === 1 ? 'day' : 'days'}`;
    });
  };

  const initialize = (scope = document) => {
    initializeRotators(scope);
    initializeTabs(scope);
    initializeVotes(scope);
    initializeCountdowns(scope);
  };

  ready(() => initialize());
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
